export { getWishlistServerAction } from 'next-flight-server-reference-proxy-loader?id=004a6e731ae53177f3d20f50dc355b62d9e9e949a5&name=getWishlistServerAction!'